const initialState = {
    logFazendaFinanceiroSinc: [],
    idFazenda: 0,
    fazenda: '',
    empresa: '',
    dias: '',
    ultimaAlteracao: ''
};

export function logFazendaFinanceiroSinc(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_LOG_FAZENDA_FINANCEIRO_SINC':
            return {
                ...state,
                logFazendaFinanceiroSinc: action.logFazendaFinanceiroSinc
            };
        case 'LOG_FAZENDA_FINANCEIRO_SINC_DETAIL':
            return {
                ...state,
                idFazenda: action.idFazenda,
                fazenda: action.fazenda,
                empresa: action.empresa,
                dias: action.dias,
                ultimaAlteracao: action.ultimaAlteracao
            };
        case "LOG_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE_LOG_FAZENDA_FINANCEIRO_SINC":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
